// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"798acf17","453":"b408d222"}[chunkId] + ".chunk.js";
};